import styled from 'styled-components';

import { COLOR, mixins } from '#@/shared/utils/styles';

import IconClickable from '../IconClickable';
import Input from '../Input';

export const SearchInputElement = styled.input`
  padding-right: 38px !important;
`;

export const ClearIcon = styled(IconClickable)`
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  right: 5px;
  ${mixins.clickable()}
  color: ${COLOR.textTertiary};
`;

export const BorderlessInput = styled(Input).attrs({ borderless: true })`
  height: initial;
  & input {
    border-radius: 4px;
  }
`;
